module.exports = __webpack_public_path__ + "img/csr_swiper_08_mobile.f567f436.jpg";